import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { ApplicationContext } from '../../App'
import { getRequestById, postRequests } from '../../services/claimsService'

interface RequestsDialogProps {
    entry: any
    open: boolean
    close: () => void
}

const getApprovedLabel = (approved: number | undefined) => {
    if (approved === undefined) {
        return 'Pending'
    }
    return new Date(approved).toLocaleString()
}

export const RequestsDialog = ({ entry, open, close }: RequestsDialogProps) => {
    const { identities, lastUpdate, setLastUpdate } = useContext(ApplicationContext)
    const [requests, setRequests] = useState<any[]>([])

    useEffect(() => {
        if (open) {
            getRequestById(entry.id).then(async (response) => {
                setRequests(response.data)
            })
        }
    }, [open, lastUpdate, entry])

    const submitRequest = (id: string) => {
        postRequests({ id })
            .then(() => {
                setLastUpdate(new Date().getTime())
            })
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .catch((err: Error) => {
                // TO DO
            })
    }

    const isRequestedDisabled = (entry: any) => {
        if (entry.type === '837' && entry.edi !== undefined) {
            return true
        }
        if (entry.type === '835' && entry.edi !== undefined) {
            return true
        }
        if (entry.type === 'message' && entry.message !== undefined) {
            return true
        }
        const ownOrg = identities.find((entry) => entry.self)
        const request = requests.find((request) => request.sender === ownOrg?.did)
        return request !== undefined
    }

    if (entry === undefined) {
        return <></>
    }

    return (
        <Dialog maxWidth="lg" open={open} onClose={close}>
            <DialogTitle>Requests</DialogTitle>
            <DialogContent style={{ minHeight: '200px', minWidth: '600px' }}>
                {requests.length === 0 ? (
                    <Typography
                        variant="h6"
                        style={{ color: 'grey', marginTop: '75px', textAlign: 'center' }}
                    >
                        There are no requests
                    </Typography>
                ) : (
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Requester</TableCell>
                                <TableCell>Request submission</TableCell>
                                <TableCell>Approval</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {requests.map((request: any) => (
                                <TableRow key={request.id}>
                                    <TableCell>
                                        {
                                            identities.find(
                                                (identity) => identity.did === request.sender,
                                            )?.displayName
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {new Date(request.submitted).toLocaleString()}
                                    </TableCell>
                                    <TableCell>{getApprovedLabel(request.approved)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                )}
            </DialogContent>
            <DialogActions>
                <Button
                    style={{ minWidth: '120px' }}
                    disableElevation={true}
                    variant="contained"
                    disabled={isRequestedDisabled(entry)}
                    onClick={() => submitRequest(entry.id)}
                >
                    Request
                </Button>
                <Button
                    style={{ minWidth: '120px' }}
                    disableElevation={true}
                    variant="contained"
                    onClick={close}
                >
                    close
                </Button>
            </DialogActions>
        </Dialog>
    )
}
